import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Info } from "lucide-react";
import { COURSE_AREAS, DISCLAIMERS } from "@/data/content";
import { SectionHeading } from "@/components/site/primitives";

export function CourseExplorer() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-20 sm:py-28 bg-[#F7F5EF]" data-testid="course-explorer-section">
      <div className="container-x">
        <SectionHeading overline="Programmes / Course Areas" title="Explore Course Areas"
          subtitle="Foundation studies can prepare you for a wide range of course areas. Expand each area to view example courses." />

        <div className="mt-12 grid lg:grid-cols-2 gap-x-8">
          {COURSE_AREAS.map((area, i) => (
            <div key={area.name} className="border-b border-slate-200">
              <button
                className="flex w-full items-center justify-between py-5 text-left"
                onClick={() => setOpen(open === i ? null : i)}
                data-testid={`course-area-${i}`}
              >
                <span className="font-serif text-lg font-bold text-[#0A1E4E]">{area.name}</span>
                <ChevronDown size={20} className={`text-[#D4AF37] transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }} className="overflow-hidden"
                  >
                    <div className="flex flex-wrap gap-2 pb-6">
                      {area.courses.map((c) => (
                        <span key={c} className="rounded-full border border-slate-300 bg-white px-3 py-1.5 text-sm text-slate-700">{c}</span>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="mt-8 flex items-start gap-3 rounded-sm border-l-4 border-[#0A1E4E] bg-white p-5 text-sm text-slate-700">
          <Info size={18} className="mt-0.5 shrink-0 text-[#0A1E4E]" />
          <p>{DISCLAIMERS.courseChoice}</p>
        </div>
      </div>
    </section>
  );
}
